export const getLanguages = data => {
  return {
    path: "languages/lookup",
    data
  };
};
